import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAnglesLeft,
  faAnglesRight, faArrowsRotate,
  faBook, faCalculator, faCarBurst,
  faChalkboardUser,
  faCheck,
  faCheckCircle, faClock, faCloudArrowUp, faCog,
  faComment,
  faCommentDots,
  faExclamationCircle, faExclamationTriangle, faFile, faFilePen,
  faFileSignature,
  faFlag,
  faFlagCheckered, faGhost, faHeartCrack,
  faIdCard,
  faInfoCircle,
  faMoon,
  faPaperPlane,
  faQuestion, faReply, faRightToBracket, faSave,
  faStopwatch,
  faSun, faTimes,
  faTimesCircle, faTrashAlt, faTruck,
  faUser,
  faUsersBetweenLines, faVideo
} from '@fortawesome/free-solid-svg-icons'
// import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

library.add(
  faAnglesLeft,
  faAnglesRight,
  faArrowsRotate,
  faBook,
  faCarBurst,
  faCalculator,
  faChalkboardUser,
  faCheck,
  faCheckCircle,
  faClock,
  faCloudArrowUp,
  faCog,
  faComment,
  faCommentDots,
  faExclamationCircle,
  faExclamationTriangle,
  faFile,
  faFilePen,
  faFileSignature,
  faFlag,
  faFlagCheckered,
  faHeartCrack,
  faGhost,
  faIdCard,
  faInfoCircle,
  faMoon,
  faPaperPlane,
  faQuestion,
  faReply,
  faRightToBracket,
  faSave,
  faSun,
  faStopwatch,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTruck,
  faUser,
  faUsersBetweenLines,
  faVideo,
);
